import React from 'react'
import PropTypes from 'prop-types'
import { message } from 'antd'
import WrappedModal from '@/components/WrappedModal'
import { cancelTuinaReservation } from '@/service/tuina'
import ReservationCancelForm from './ReservationCancelForm'

class ReservationCancelModal extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    record: PropTypes.object,
    zIndex: PropTypes.number,
    onSuccess: PropTypes.func
  }

  handleOk = async (form) => {
    const { record, onSuccess } = this.props
    const fields = await form.current.validateFields()
    await cancelTuinaReservation(record.id, { reason: fields.reason })
    message.success('已取消预约')
    if (typeof onSuccess === 'function') onSuccess()
  }

  render () {
    const { children, zIndex } = this.props
    return (
      <WrappedModal
        children={children}
        title="取消预约"
        okText="取消预约"
        okButtonProps={{ danger: true, size: 'large' }}
        cancelButtonProps={{ size: 'large' }}
        width={480}
        zIndex={zIndex}
        baseComponent={<ReservationCancelForm />}
        onOk={this.handleOk}
      />
    )
  }
}

export default ReservationCancelModal
